// Single source of truth for the public install destination.
// The product is live: every "Add to Chrome" CTA across the site (hero, navbar,
// pricing, final CTA) points here, so the install destination is a one-line change.
export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/ahpeigdlmjnohnmjbeenjobakpndniap";

// The founding-team call (20 minutes) linked from /for: the hello@intakall.io calendar booking page.
export const BOOKING_URL = "https://calendar.app.google/mJUdFDmxwvxLN5up8";

// Analytics (2026-10-23): which page and which outside link (?ref=tiktok) brought an install or a sign-up.
// The Chrome Web Store counts installs per utm_source; the app keeps ?ref= until the person signs in.
const TAG = /^[a-z0-9_-]{1,40}$/i;

function refTag(search: string): string | null {
  const ref = new URLSearchParams(search).get("ref");
  return ref && TAG.test(ref) ? ref : null;
}

const currentSearch = () => (typeof window === "undefined" ? "" : window.location.search);

/** The store link for one "Add to Chrome" button, tagged with its place on the site. */
export function storeUrl(placement: string, search = currentSearch()): string {
  return `${CHROME_STORE_URL}?utm_source=${refTag(search) ?? "website"}&utm_medium=${placement}`;
}

/** The app's sign-up link, tagged with the outside link that brought the visitor, or else the button's place. */
export function signUpUrl(placement: string, search = currentSearch()): string {
  return `https://app.intakall.io/?ref=${refTag(search) ?? `site_${placement}`}`;
}
